import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonLoading, IonPage, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { arrowBack, calendar } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { agendamentoProjetoCarregar, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import "./OrdensAgendamentos.css";

type Props = {
  projetoid: string;
  configs: Object;
  abrirInserirAgendamento: boolean;
  onDismiss: () => void;
};

const OrdensAgendamentos: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const location = useLocation<any>();
  const [operacaoCarregada, setOperacaoCarregada] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [listaAgendamentos, setListaAgendamentos] = useState<any>([]);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {

    setEsconderMenu(true);

  });


  let params: any = {
    projetoid: "",
    abrirInserirAgendamento: false,
    configs: "",
  }
  params = useParams();

  if (location && location.state && location.state.projetoid) {
    params.projetoid = location.state.projetoid;
    params.configs = location.state.configs;
    params.abrirInserirAgendamento = location.state.abrirInserirAgendamento;
  }


  if (props.projetoid) {
    params = {
      projetoid: props.projetoid,
      configs: props.configs,
      abrirInserirAgendamento: props.abrirInserirAgendamento
    }
  }


  function carregarAgendamentos() {
    if (params.projetoid != "" && params.projetoid != undefined) {
      if (!operacaoCarregada) {
        setOperacaoCarregada(true);
        consultarAgendamentos(params.projetoid);
      }
    }
    return "";
  }


  function consultarAgendamentos(projetoid: any) {
    const consultarAgendamentoPorProjeto = async () => {

      setShowLoading(true);

      requestService(agendamentoProjetoCarregar.url.replaceAll("{projetoid}", projetoid.replaceAll(/#/g, "%23")), {
        method: agendamentoProjetoCarregar.method,
        headers: [
          ["token", window.localStorage.getItem("token")],
          ["perfil", window.localStorage.getItem("perfil")],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log("response.Items", response.Items);
          setListaAgendamentos(response.Items);
        },
        (error: any) => {
          if (error.status === 426) { // atualizar versao
            history.replace("/atualizar");
          }
          else if (error.status !== 408) {
            history.replace("/primeiroacesso/");
          }
        }).finally(() => {
          setShowLoading(false);
        });;
    }

    consultarAgendamentoPorProjeto();

  }



  function adicionaZeroNaData(numero: any) {
    if (numero <= 9)
      return "0" + numero;
    else
      return numero;
  }

  function formatarDataHora(data: Date) {
    return adicionaZeroNaData(data.getDate().toString()) + "/" + (adicionaZeroNaData(data.getMonth() + 1).toString()) + " " + ("0" + data.getHours().toString()).substr(-2) + ":" + ("0" + data.getMinutes().toString()).substr(-2);
  }

  function formatarDataPeriodo(data: Date, periodo: string) {
    return adicionaZeroNaData(data.getDate().toString()) + "/" + (adicionaZeroNaData(data.getMonth() + 1).toString()) + " " + periodo;
  }

  const loadAgendamentos = () => {

    console.log();
    if (listaAgendamentos == undefined) return;

    if (listaAgendamentos.length === 0) {
      return (

        <IonItem lines="full" key={"semAgenda"}>

          <IonLabel>
            <h2 style={{ "verticalAlign": "middle" }}><strong>Nenhuma agenda em aberto</strong></h2>
          </IonLabel>

        </IonItem>


      );
    }

    return listaAgendamentos.map((value: any, index: any) => (
      <IonItem lines="full" detail onClick={(e: any) => {


        history.push("../agendamentos/agendamentosdetalhes", { agendamentoid: value.pk })

      }} key={index}>
        <IonIcon icon={calendar} slot="start"> </IonIcon>
        <IonLabel>
          <h2 style={{ "verticalAlign": "middle" }}><strong>{(value.parametroMostrarHorario ? formatarDataHora(new Date(value.dataAgendamento)) : formatarDataPeriodo(new Date(value.dataAgendamento), value.periodoAgendamento))}  </strong></h2>
          <h3>{value.descricaoAgendamento + ' - ' + value.tipoAgendamento + ' - ' + value.prestadorNome}</h3>
        </IonLabel>

      </IonItem>
    ));
  }


  return (

    <IonPage className="OrdensAgendamentos">
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <div>
            {carregarAgendamentos()}
          </div>
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack();/*.replace("/empresa/operacoes", { recarregar: false }); */ }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Agenda</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen={false}>


        {loadAgendamentos()}


        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>

    </IonPage>
  );


};

export default OrdensAgendamentos;